module.exports = __webpack_public_path__ + "static/mfg-brokerage-2-min.c3623180.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/brokerage/mfg-brokerage-2-min.png
// module id = 491
// module chunks = 70392746020482